var map = {
	"./americano-thumb.png": "69de",
	"./americano.png": "f431",
	"./cappuccino-thumb.png": "3b78",
	"./cappuccino.png": "2f42",
	"./doppio-thumb.png": "7223",
	"./doppio.png": "c593",
	"./espresso-thumb.png": "2ba1",
	"./espresso.png": "5cd4",
	"./flatwhite-thumb.png": "79db",
	"./flatwhite.png": "709a",
	"./latte-thumb.png": "e1638",
	"./latte.png": "7975",
	"./longblack-thumb.png": "34e5",
	"./longblack.png": "5b42",
	"./macchiato-thumb.png": "782d",
	"./macchiato.png": "2647"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f05e";